import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	forEach as ForEach, cloneDeep, isEqual, isEmpty,
} from 'lodash';
import Validator from 'validatorjs';
import { updateProgressButton } from '@config/utils';
import { ProgressButton } from '@components';
import Actions from '@redux/app';
import FieldGroup from './FieldGroup';

class Form extends Component {
	constructor(props) {
		super(props);
		this.state = {
			validations : {
				username : null,
				password : null,
			},
		};
	}

	componentDidUpdate({ username : prevUsername }) {
		const { username } = this.props;
		if (prevUsername !== username && username.length > 0) {
			this.onChange('username')({ target : { value : username } });
		}
	}

	shouldComponentUpdate = ({ credentials, username, progressButton }, { validations }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(credentials, lastProps.credentials)
			|| !isEqual(progressButton, lastProps.progressButton)
			|| !isEqual(username, lastProps.username)
			|| !isEqual(validations, lastState.validations)
		);
	}

	validateForm = (data) => {
		const { adb2cEnabled } = window;
		const newState = cloneDeep(this.state);

		let rules = {
			username : 'required|email',
		};

		if (!adb2cEnabled) {
			rules = {
				...rules,
				password : 'required',
			};
		}

		const validation = new Validator(data, rules);
		const result = validation.passes();
		ForEach(newState.validations, (value, key) => {
			if (!isEmpty(validation.errors.get(key))) newState.validations[key] = 'error';
		});
		this.setState(newState);

		return result;
	}

	onChange = (name) => (event) => {
		const { setCredentials } = this.props;
		const { validations } = this.state;
		if (validations[name] === 'error') {
			const newState = cloneDeep(this.state);
			newState.validations[name] = null;
			this.setState(newState);
		}
		setCredentials({
			[name] : event.target.value,
		});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const username = document.getElementById('usernameInput').value;
		const password = document.getElementById('passwordInput').value;

		const { dispatch, onSubmit } = this.props;
		if (!this.validateForm({ username, password })) {
			updateProgressButton({
				dispatch,
				module   : 'app',
				property : 'loginData.progressButton',
				value    : 'error',
			});
			return;
		}
		onSubmit({
			username,
			password,
		});
	}

	handleADSubmit = (e) => {
		e.preventDefault();
		const username = document.getElementById('usernameInput').value;

		const { dispatch, onSubmit } = this.props;
		if (!this.validateForm({ username })) {
			updateProgressButton({
				dispatch,
				module   : 'app',
				property : 'loginData.progressButton',
				value    : 'error',
			});
			return;
		}
		onSubmit({ username });
	}

	render() {
		const {
			credentials,
			progressButton,
		} = this.props;
		const { adb2cEnabled } = window;

		const { validations } = this.state;

		return (
			<form onSubmit={this.handleSubmit}>
				<FieldGroup
					id="usernameInput"
					name="username"
					type="text"
					value={credentials.username}
					onChange={this.onChange('username')}
					label="Email"
					placeholder="Email"
					icon=""
					validationState={validations.username}
				/>
				<Choose>
					<When condition={adb2cEnabled}>
						<ProgressButton
							state={progressButton}
							type="submit"
							className="btn btn-block btn-success btn-rounded margin-top-30"
							text="Log In"
							onClick={this.handleADSubmit}
						/>
					</When>
					<Otherwise>
						<FieldGroup
							id="passwordInput"
							type="password"
							name="password"
							value={credentials.password}
							onChange={this.onChange('password')}
							label="Password"
							placeholder="Password"
							validationState={validations.password}
						/>
						<ProgressButton
							state={progressButton}
							type="submit"
							className="btn btn-block btn-success btn-rounded margin-top-30"
							text="Log In"
						/>
					</Otherwise>
				</Choose>
			</form>
		);
	}
}

const mapStateToProps = ({
	app : {
		loginData,
	},
}) => ({
	...loginData,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	setCredentials : bindActionCreators(Actions, dispatch).setCredentials,
});

Form.propTypes = {
	credentials    : PropTypes.object,
	username       : PropTypes.string,
	dispatch       : PropTypes.func.isRequired,
	onSubmit       : PropTypes.func.isRequired,
	progressButton : PropTypes.string,
	setCredentials : PropTypes.func.isRequired,
};

Form.defaultProps = {
	credentials    : {},
	username       : '',
	progressButton : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
